export interface UserInfo {
  id: string;
  name: string;
  preferredUsername: string;
  email: string;
  emailVerified: boolean;
  locale: string;
  roles: string[];
  createdAt: Date;
}

export const ROLE_SUPER_ADMINISTRATOR = 'ROLE_SUPER_ADMINISTRATOR';
export const ROLE_VTEX_LOGISTIC_WH_SYNC = 'ROLE_VTEX_LOGISTIC_WH_SYNC';
export const ROLE_VTEX_LOGISTIC_READ = 'ROLE_VTEX_LOGISTIC_READ';
export const ROLE_VTEX_USER_READ = 'ROLE_VTEX_USER_READ';
export const ROLE_VTEX_USER_WRITE = 'ROLE_VTEX_USER_WRITE';
export const ROLE_APPLICATION_SETTINGS_READ = 'ROLE_APPLICATION_SETTINGS_READ';
export const ROLE_APPLICATION_SETTINGS_WRITE = 'ROLE_APPLICATION_SETTINGS_WRITE';
export const ROLE_VTEX_CATALOG_READ = 'ROLE_VTEX_CATALOG_READ';
export const ROLE_VTEX_CATALOG_WRITE = 'ROLE_VTEX_CATALOG_WRITE';
export const ROLE_VTEX_SHOP_SELLERS_READ = 'ROLE_VTEX_SHOP_SELLERS_READ';
export const ROLE_VTEX_SHOP_SELLERS_WRITE = 'ROLE_VTEX_SHOP_SELLERS_WRITE';
export const ROLE_USER_GROUPS_READ = 'ROLE_USER_GROUPS_READ';
export const ROLE_USER_GROUPS_WRITE = 'ROLE_USER_GROUPS_WRITE';
export const ROLE_USERS_READ = 'ROLE_USERS_READ';
export const ROLE_USERS_WRITE = 'ROLE_USERS_WRITE';
export const ROLE_VTEX_RETIFICATION_READ = 'ROLE_VTEX_RETIFICATION_READ';
export const ROLE_VTEX_RETIFICATION_WRITE = 'ROLE_VTEX_RETIFICATION_WRITE';
export const ROLE_LABELING_READ = 'ROLE_LABELING_READ';
export const ROLE_LABELING_WRITE = 'ROLE_LABELING_WRITE';
export const ROLE_AUDIT_READ = 'ROLE_AUDIT_READ';
export const ROLE_AUDIT_MINIMAL_READ = 'ROLE_AUDIT_MINIMAL_READ';
export const ROLE_VTEX_CATALOG_MINIMAL_READ = 'ROLE_VTEX_CATALOG_MINIMAL_READ';
export const ROLE_VTEX_SHOP_SELLERS_MIN_READ = 'ROLE_VTEX_SHOP_SELLERS_MIN_READ';
export const ROLE_VTEX_ORDERS_READ = 'ROLE_VTEX_ORDERS_READ';
export const ROLE_VTEX_ORDERS_WRITE = 'ROLE_VTEX_ORDERS_WRITE';
export const ROLE_VTEX_ORDERS_MINIMAL_READ = 'ROLE_VTEX_ORDERS_MINIMAL_READ';
